let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("fjOTL"), load("9UbYE")]).then(() => parcelRequire('3EL4j'));